import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ResponsiveShadow from './components/ResponsiveShadow';
import DefaultModal from './components/modals/DefaultModal';
import Pagination10 from './components/Pagination10';
import { logout } from './api/logout';
import usePagination10 from './components/hooks/usePagination10';
import LayoutLogin from './components/LayoutLogin';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import TableContainer from './components/TableContainer';
import DataTable from './components/DataTable';
import PaginationBar from './components/PaginationBar';

function SelecionaEntidade() {
  const [vinculo, setVinculo] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [modalData, setModalData] = useState({
    show: false,
    type: '',
    message: '',
  });
  const closeDefaultModal = () => {
    setModalData(prevModalData => ({ ...prevModalData, show: false }));
  };
  const navigate = useNavigate();

  // ... (suas funções useEffect, handleAdvance, handleLogout permanecem as mesmas)
  useEffect(() => {
    const storedOptions = localStorage.getItem('vinculos');
    if (storedOptions) {
      try {
        const parsedOptions = JSON.parse(storedOptions);
        setVinculo(parsedOptions);

        if (parsedOptions.length === 1) {
          const singleOption = parsedOptions[0];
          localStorage.setItem(
            'entidade',
            JSON.stringify(singleOption.entidade)
          );
          localStorage.setItem('cnpj', singleOption.entidade.cnpj);
          localStorage.setItem('vinculo', JSON.stringify(singleOption));
          navigate('/home');
        }
      } catch (error) {
        console.error('Erro ao parsear os dados do localStorage:', error);
      }
    }
  }, [navigate]);

  // Função para normalizar strings (remover acentos e converter para minúsculas)
  const normalizeString = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  };

  // Filtrar entidades por nome
  const entidadesFiltradas = Array.isArray(vinculo)
    ? vinculo.filter(option => {
        const normalizedBusca = normalizeString(filtro);
        return normalizeString(option.entidade.nome).includes(normalizedBusca);
      })
    : [];

  // Paginação das entidades filtradas
  const totalItems = entidadesFiltradas.length;
  const { setPagination } = usePagination10(totalItems);
  const selectedEntidades = entidadesFiltradas.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  const handleLogout = () => {
    const token = localStorage.getItem('token');
    if (token) { logout(token).catch(() => {}); }
    localStorage.clear();
    try { sessionStorage.setItem('justLoggedOut','true'); sessionStorage.removeItem('loginRedirectMessage'); } catch (e) { }
    navigate('/');
  };

  return (
    <LayoutLogin>
      <ResponsiveShadow>
        <PageHeader
          title="Entidades Vinculadas ao Usuário"
          icon="bi-building"
          onLogout={handleLogout}
        />
        <PageContent>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-2">
              {/* Botões removidos - navegação direta pelo botão visualizar */}
            </div>
            <div className="col-md-4">
              <div className="input-group input-group-sm">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Buscar por Nome da Entidade"
                  value={filtro}
                  onChange={e => setFiltro(e.target.value.toUpperCase())}
                />
              </div>
            </div>
          </div>

          <TableContainer>
                        <DataTable style={{ fontSize: '0.8rem' }} head={
                <tr>
                  <th scope="col" className="px-2 d-none d-md-table-cell">
                    CNPJ
                  </th>
                  <th scope="col" className="px-2">
                    Nome da Entidade
                  </th>
                  <th scope="col" className="px-2">
                    Nome Fantasia
                  </th>
                  <th scope="col" className="px-2">
                    Cidade
                  </th>
                  <th scope="col" className="px-2">
                    UF
                  </th>
                  <th scope="col" className="px-2">
                    Ações
                  </th>
                </tr>}>
              <tbody>
                {selectedEntidades.map((option, index) => (
                  <tr key={index}>
                    <td className="px-2 d-none d-md-table-cell">
                      {option.entidade.cnpj}
                    </td>
                    <td className="px-2">{option.entidade.nome}</td>
                    <td className="px-2">
                      {option.entidade.nomeFantasia || '-'}
                    </td>
                    <td className="px-2">
                      {option.entidade.logrCidade || '-'}
                    </td>
                    <td className="px-2">{option.entidade.logrUf || '-'}</td>
                    <td className="px-2">
                      <button
                        className="btn me-1 p-0"
                        onClick={e => {
                          e.stopPropagation(); // Impede que o click da linha seja disparado
                          // Navega diretamente com esta entidade
                          localStorage.setItem(
                            'entidade',
                            JSON.stringify(option.entidade)
                          );
                          localStorage.setItem('cnpj', option.entidade.cnpj);
                          localStorage.setItem(
                            'vinculo',
                            JSON.stringify(option)
                          );
                          navigate('/home');
                        }}
                        title="Visualizar Entidade"
                        style={{
                          background: 'transparent',
                          border: 'none',
                          color: '#0489fdff',
                        }}
                      >
                        <i className="bi bi-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </DataTable>
          </TableContainer>
        </PageContent>
        <PaginationBar setPagination={setPagination}/>
      </ResponsiveShadow>

      <DefaultModal
        show={modalData.show}
        type={modalData.type}
        onClose={closeDefaultModal}
        message={modalData.message}
      />
    </LayoutLogin>
  );
}

export default SelecionaEntidade;
